import { NgModule } from '@angular/core';
import { provideNavConfig } from '@capital-access/common/navigation';
import { CommonRouterModule } from '@capital-access/common/router';
import { AdvancedSearchNavConfigProvider } from './advanced-search-nav-config.provider';
import { CanAccessAdvancedSearchGuard } from './advanced-search-navigation-guards';
import { ADVANCED_SEARCH_PATH } from './constants';

export const loadModule = () =>
  import('@capital-access/advanced-search/client').then(m => m.AdvancedSearchClientModule);

@NgModule({
  imports: [
    CommonRouterModule.forFeature({
      authorized: [
        {
          path: ADVANCED_SEARCH_PATH,
          canActivate: [CanAccessAdvancedSearchGuard],
          loadChildren: loadModule
        }
      ]
    })
  ],
  providers: [provideNavConfig(AdvancedSearchNavConfigProvider), CanAccessAdvancedSearchGuard]
})
export class AdvancedSearchLazyModule {}
